import {
    ExpandIcon,
    ReloadIcon
} from 'common/components/icons';

import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import CudaPaper from 'common/components/CudaPaper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Translate } from 'react-i18nify-lite';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    container: {
        padding: '10px 1px',
        alignSelf: 'flex-start'
    },
    emptyTableCell: {
        textAlign: 'center',
        fontSize: '16px',
        color: '#777777',
        fontWeight: '300',
        height: '200px',
    },
    actionHeadCell: {
        width: '100px',
        textAlign: 'center'
    },
    actionCell: {
        display: 'flex',
        justifyContent: 'center'
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
      },
    expandOpen: {
    transform: 'rotate(180deg)',
    },
    reloadButtonDiv: {
        margin: 0,
    },
}

class Dashboard extends React.Component {
    state = { expanded: true };
  
    handleExpandClick = () => {
      this.setState(state => ({ expanded: !state.expanded }));
    };
  
    render() {
        const {
                classes,
                isLoading,
                items,
                reload,
            } = this.props;
    
    return (
        <Grid className={classes.container}>
            <CudaPaper loading={isLoading}>
        <CardActions className={classes.actions} disableactionspacing="true">
          Mixed Health Servers
          <Button className={classes.button} onClick={reload}>
            <ReloadIcon />
          </Button>
          <IconButton
            className={classnames(classes.expand, {
              [classes.expandOpen]: this.state.expanded,
            })}
            onClick={this.handleExpandClick}
            aria-expanded={this.state.expanded}
            aria-label="Show more"
          >
            <ExpandIcon />
          </IconButton>
        </CardActions>

            <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>

            <Grid item xs={12} className={classes.tableContainer}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Server IP:Port</TableCell>
                                <TableCell>Managed service</TableCell>
                                <TableCell>Account</TableCell>
                                <TableCell>cwaf</TableCell>
                                <TableCell>DCs down</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.length > 0 ?
                                items.map((server, i) => {
                                    return (
                                        <TableRow key={i}>
                                            <TableCell>
                                                {server.server_hostname}
                                                :
                                                {server.server_port}
                                            </TableCell>
                                            <TableCell>
                                                {server.managed_service_name}
                                            </TableCell>
                                            <TableCell>
                                                {server.account_name}
                                            </TableCell>
                                            <TableCell>
                                                {server.cwaf_hostname}
                                            </TableCell>
                                            <TableCell>
                                                {server.dc_ids.join(", ")}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                                :
                                <TableRow >
                                    <TableCell colSpan="7" className={classes.emptyTableCell}>
                                        <Translate value="applications.problematicServers.noServers" />
                                    </TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
            </Grid>
            </Collapse>
            
            </CudaPaper>
        </Grid>
    )};


};

export default withStyles(styles)(Dashboard);
